// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Loader from "../../../Components/Loader";
// import { SeminarService } from "../../../DataService/SeminarService";
// import { AdminIcon } from "../../../Icons/AdminIcon";
// import { SeminarDto } from "../../../Types/SeminarServiceTypes";
// import { Icon } from "../../../Icons/Icon";
// import { Button } from "../../../Components/Button";
// import '../AdminGroups.css'
// const SeminarsListPage: React.FC = () => {
//   const [seminars, setSeminars] = useState<SeminarDto[]>([]);
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => { load(); }, []);

//   const load = async () => {
//     setLoading(true);
//     const data = await SeminarService.GetSeminars();
//     if (data) setSeminars(data);
//     setLoading(false);
//   };

//   return (
//     <div className="admin-pageadmin-groups-container">
//       <div className="admin-groups-container-margin">
//         <div className="admin-groups-title-container">
//           <button onClick={() => navigate("/admin-home")} className="admin-courses-home-link" style={{ background: "none", border: "none" }}>
//             <Icon.ArrowLeft /> Tillbaka
//           </button>
//           <h1 className="admin-groups-title-text">Seminarier</h1>
//           <p className="admin-groups-title-paragraph">Översikt över kommande och tidigare seminarier</p>

//           <div style={{ marginTop: 12 }}>
//             <Button className="submit-button" onClick={() => navigate("/admin-seminars/send")} text={<><AdminIcon.MailSend /> Skicka inbjudningar</>} />
//           </div>
//         </div>

//         {loading ? (
//           <div style={{ display: "flex", justifyContent: "center", paddingTop: 40 }}>
//             <Loader loaderSize="LARGE" bgColor="#7C444F" />
//           </div>
//         ) : (
//           <div className="admin-groups-tab-content-grid">
//             {seminars.map(s => (
//               <div key={s.id} className="card">
//                 <div className="card-header">
//                   <h3>{s.title}</h3>
//                   <p>{s.date} {s.time}</p>
//                 </div>
//                 <div className="card-content">
//                   <p>{s.description}</p>
//                   <p>Grupper: {s.groups.map(g => g.groupName).join(", ")}</p>
//                 </div>
                
//               </div>
//             ))}
//             {seminars.length === 0 && <p>Inga seminarier.</p>}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SeminarsListPage;

import React, { useEffect, useState } from "react";

import '../AdminGroups.css'
import './SeminarCard.css'
import Loader from "../../../Components/Loader";
import { Badge } from "../../../Components/Badge";
import { GroupService } from "../../../DataService/GroupService";
import { SeminarService } from "../../../DataService/SeminarService";
import { AdminIcon } from "../../../Icons/AdminIcon";
import { GroupDto } from "../../../Types/GroupServiceTypes";
import { CreateSeminarDto, SeminarDto } from "../../../Types/SeminarServiceTypes";
import CreateOrEditSeminarModal from "./CreateOrEditSeminarModal";
import { Button } from "../../../Components/Button";
import { useNavigate } from "react-router-dom";

export const SeminarsListPage = () => {
     const navigate = useNavigate();
  const [seminars, setSeminars] = useState<SeminarDto[]>([]);
  const [groups, setGroups] = useState<GroupDto[]>([]);

  const [loadingSeminars, setLoadingSeminars] = useState(true);
  const [loadingGroups, setLoadingGroups] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [editingSeminar, setEditingSeminar] = useState<SeminarDto | null>(null);
  const [isSaving, setIsSaving] = useState(false);
  const seminarCount = seminars.length;
  const seminarWithDateCount = seminars.filter(sem => Boolean(sem.date)).length;

  const loadSeminars = async () => {
    setLoadingSeminars(true);
    const result = await SeminarService.GetSeminars();
    if (result) setSeminars(result);
    setLoadingSeminars(false);
  };

  const loadGroups = async () => {
    setLoadingGroups(true);
    const result = await GroupService.GetGroups();
    if (result) setGroups(result);
    setLoadingGroups(false);
  };

  useEffect(() => {
    loadSeminars();
    loadGroups();
  }, []);

  const handleCreate = () => {
    setEditingSeminar(null);
    setShowModal(true);
  };

  const handleEdit = (seminar: SeminarDto) => {
    setEditingSeminar(seminar);
    setShowModal(true);
  };

  // const handleSubmit = async (dto: any) => {
  //   setIsSaving(true);

  //   if (editingSeminar) {
  //     await SeminarService.UpdateSeminar(editingSeminar.id, dto);
  //   } else {
  //     await SeminarService.CreateSeminar(dto);
  //   }

  //   await loadSeminars();
  //   setIsSaving(false);
  //   setShowModal(false);
  // };

const handleSubmit = async (dto: CreateSeminarDto, options?: { sendInvites?: boolean }) => {
  setIsSaving(true);
  let result;

  if (editingSeminar) {
    result = await SeminarService.UpdateSeminar(editingSeminar.id, dto);
  } else {
    result = await SeminarService.CreateSeminar(dto);
  }

  // If modal requested sendInvites
  if (options?.sendInvites && result?.id) {
    await SeminarService.SendSeminarInvites(result.id);
  }

  await loadSeminars();
  setIsSaving(false);
  setShowModal(false);
};

  const handleDelete = async (seminarId: string) => {
    if (!window.confirm("Är du säker på att du vill ta bort seminariet?")) return;
    await SeminarService.DeleteSeminar(seminarId);
    await loadSeminars();
  };

  return (
    <div className="admin-page-shell admin-groups-page-shell">
      <header className="admin-page-header admin-groups-title-container">
        <div>
          <h1 className="admin-page-title admin-groups-title-text">Seminarier</h1>
          <p className="admin-page-subtitle admin-groups-title-paragraph">
            Hantera alla seminarier och skicka inbjudningar
          </p>
        </div>

        <Button
          className="submit-button admin-groups-cta-button"
          onClick={handleCreate}
          text={
            <>
              <AdminIcon.PlusSign width={18} height={18} fill="white" />
              Skapa seminarium
            </>
          }
        />
      </header>

      <div className="admin-groups-overview-grid">
        <div className="admin-groups-overview-card">
          <span>Seminarier</span>
          <strong>{loadingSeminars ? '...' : seminarCount}</strong>
          <p>Alla skapade seminarier i översikten.</p>
        </div>
        <div className="admin-groups-overview-card">
          <span>Med datum</span>
          <strong>{loadingSeminars ? '...' : seminarWithDateCount}</strong>
          <p>Seminarier med planerad tid.</p>
        </div>
      </div>

        {loadingSeminars || loadingGroups ? (
          <div className="flex-center" style={{ padding: 80 }}>
            <Loader loaderSize="LARGE" bgColor="hsl(var(--primary))" />
          </div>
        ) : (
          <div className="admin-groups-tab-content-grid admin-groups-seminar-grid">
            {seminars.map((sem) => (
              <div key={sem.id} className="seminar-card seminar-card--elevated">
                <div className="seminar-card-header-row">
                  <Badge variant={sem.groups.length > 0 ? 'default' : 'secondary'}>{sem.groups.length} grupper</Badge>
                  <Badge variant="outline">{sem.date ? 'Planerad' : 'Utan datum'}</Badge>
                </div>

                <h3 className="seminar-card-title">{sem.title}</h3>
                <p className="seminar-card-desc">{sem.description}</p>

                <p className="seminar-card-meta">
                  📅 {sem.date || "Ej datum satt"} – {sem.time || "Ingen tid"}
                </p>

                <p className="seminar-card-meta">
                  🎯 {sem.groups.length} grupper
                </p>

                <div className="seminar-card-actions">

                  <Button
                    size="sm"
                    className="submit-button"
                    style={{ flex: '0 0 2.75rem', width: '2.75rem', paddingInline: 0 }}
                    text={<AdminIcon.EditPencil width={18} height={18} fill="white" />}
                    onClick={() => handleEdit(sem)}
                  />
                  <Button
                    size="sm"
                    className="submit-button"
                    style={{ flex: '1 1 auto', minWidth: 0 }}
                    text="Skicka"
                    onClick={() => navigate(`/admin/seminars/send?id=${sem.id}`)}
                  />
                  <Button
                    size="sm"
                    className="warning-button"
                    style={{ flex: '0 0 2.75rem', width: '2.75rem', paddingInline: 0 }}
                    text={<AdminIcon.Trashcan width={18} height={18} fill="white" />}
                    onClick={() => handleDelete(sem.id)}
                  />

                </div>
              </div>
            ))}
          </div>
        )}

        {showModal && (
          <CreateOrEditSeminarModal
            onClose={() => setShowModal(false)}
            seminar={editingSeminar}
            groups={groups}
            isSaving={isSaving}
            onSubmit={handleSubmit}
          />
        )}

    </div>
  );
};
